import { User } from 'firebase/auth';

export type AuthContextType = {
  user: User | null | undefined;
};

export const DefaultAuthContext = {
  user: null,
};
